import { environment } from '../../environments/environment';

const BASE_URL = environment.apiEndpoint;
const API = '/api';
const API_V1 = environment.adminApiVersion;
const API_V1_FRONT = environment.frontApiVersion;
const API_V2_FRONT = environment.frontApiVersion1;

export const CONFIG = {
  EncrDecrKey: '123456$#@$^@1ERF',
  // oauth
  userAuthURL: BASE_URL + API_V1 + '/oauth/signin',
  forgotPassURL: BASE_URL + API_V1 + '/oauth/password/forgot',
  validateResetPassURL: BASE_URL + API_V1 + '/oauth/password/validate_reset_token',
  resetPassURL: BASE_URL + API_V1 + '/oauth/password/reset',

  patientActivateURL: BASE_URL + API_V2_FRONT + '/oauth/verifyemail/',

  patientActivateTempURL: BASE_URL + API_V2_FRONT + '/oauth/verifyemailtemp/',

  verifyOTPURL: BASE_URL + API_V1 + '/oauth/verifOtp',
  // after oauth
  getUserProfileIdURL: BASE_URL + API_V1 + '/user/profile',

  /* DASHBOARD - API */
  getAllDashboardTotalCountURL: BASE_URL + API_V1 + '/oauth/totalcount',
  getInventoryStatsData: BASE_URL + API_V1 + '/pharmacy/dashboard/data',
  getSinglePharmacyID: BASE_URL + API_V1 + '/pharmacy/dashboard/listids',
  getSingleHospitalID: BASE_URL + API_V1 + '/hospital/dashboard/listids',
  getSingleDoctorID: BASE_URL + API_V1 + '/consultations/dashboard/listids',
  getOrderStatsData: BASE_URL + API_V1 + '/orders/dashboard/data',
  getconsultationData: BASE_URL + API_V1 + '/consultations/dashboard/data',
  getlabData: BASE_URL + API_V1 + '/lab/dashboard/data',
  getIPDData: BASE_URL + API_V1 + '/ipd/dashboard/data',
  getbillingData: BASE_URL + API_V1 + '/billing/dashboard/data',
  getPatientStatsData: BASE_URL + API_V1 + '/patient/dashboard/data',
  exportpatient :  BASE_URL + API_V1 + '/patient/hospital/dashboard/data',
  getPurchaseStatsData: BASE_URL + API_V1 + '/purchase/dashboard/data',
  getPatientStatsDataHospital: BASE_URL + API_V1 + '/patient/hospital/dashboard/data',
  getOTData: BASE_URL + API_V1 + '/ot/dashboard/data',
  getItemWiseMarginData: BASE_URL + API_V1 + '/purchase/dashboard/data/viewMargin',
  
  /* CMS MANAGEMENT - API */
  createCmsURL: BASE_URL +   API_V1 + '/content_page/create',
  updateCmsURL: BASE_URL + API_V1 + '/content_page/update/',
  getCmsByIdURL: BASE_URL + API_V1 + '/content_page/show/',
  getAllCmsListURL: BASE_URL + API_V1 + '/content_page/list',
  changeCmsStatusURL: BASE_URL + API_V1 + '/content_page/change_status',
  getCmsBySlugURL: BASE_URL + API_V1 + '/content/',

  /* EMAIL TEMPLATE - API */
  updateEmailURL: BASE_URL + API_V1 + '/email_template/update/',
  getEmailByIdURL: BASE_URL + API_V1 + '/email_template/show/',
  getAllEmailListURL: BASE_URL + API_V1 + '/email_template/list',
  changeEmailStatusURL: BASE_URL + API_V1 + '/email_template/change_status',

  /* FAQ MANAGEMENT - API */
  getAllFaqListURL: BASE_URL + API_V1 + '/faq/list',
  getFaqByIdURL: BASE_URL + API_V1 + '/faq/show/',
  changeFaqStatusURL: BASE_URL + API_V1 + '/faq/change_status',
  getFaqTopicListURL: BASE_URL + API_V1 + '/faq_topic/list',
  deleteFaqURL: BASE_URL + API_V1 + '/faq/delete/',
  updateFaqURL: BASE_URL + API_V1 + '/faq/update/',
  createFaqURL: BASE_URL + API_V1 + '/faq/create',

  /* MANAGE SUBADMIN - API */
  getAllSubadminListURL: BASE_URL + API_V1 + '/subadmin/list',
  changeSubadminPassURL: BASE_URL + API_V1 + '/subadmin/password/change',
  changeSubadminStatusURL: BASE_URL + API_V1 + '/subadmin/change_status',
  changeOTPSubadminStatusURL: BASE_URL + API_V1 + '/subadmin/change_otp_status',
  deleteSubadminURL: BASE_URL + API_V1 + '/subadmin/delete/',
  getActiveRoleURL: BASE_URL + API_V1 + '/role/list_active/0',
  getSubadminByIdURL: BASE_URL + API_V1 + '/subadmin/show/',
  updateSubadminURL: BASE_URL + API_V1 + '/subadmin/update/',
  createSubadminURL: BASE_URL + API_V1 + '/subadmin/create',
  getSubAdminGroupId: BASE_URL + API_V1 + '/subadmin/group',
  getSubAdminGroupPermissionList: BASE_URL + API_V1 + '/subadmin/group/permissionlist', 
  getSubAdminGroupUpdate: BASE_URL + API_V1 + '/subadmin/group/update',
  getAllReferralsURL: BASE_URL + API_V1 + '/referral/all-referrals-by-permission',
  getAllPharNonLinkedURL: BASE_URL + API_V1 + '/referral/non-referral-linked-pharmacies',
  getAllReferralsUpdate: BASE_URL + API_V1 + '/referral/subadmin-update',
  setSubscription: BASE_URL + API_V1 + '/subadmin/set_subscription',

  //subadmin/manage-doctor - API List
  managedoctorPermissionList: BASE_URL + API_V1 + '/doctor/subadmin/doctor/list', 
  //updateManagedoctorList update-list
  updateManagedoctorList : BASE_URL + API_V1 + '/doctor/subadmin/doctor/update-list',


  /* MANAGE USER - API */
  getAllManageUserListURL: BASE_URL + API_V1 + '/user/list',
  changeManageUserPassURL: BASE_URL + API_V1 + '/user/password/change',
  changeManageUserStatusURL: BASE_URL + API_V1 + '/user/change_status',
  changeStatusClinicURL: BASE_URL + API_V1 + '/doctor/updateStatus/appointment_slot',
  deleteManageUserURL: BASE_URL + API_V1 + '/user/delete/',
  deleteUserProfileURL: BASE_URL + API_V1 + '/user/delete-profile/',
  getManagerUserByIdURL: BASE_URL + API_V1 + '/user/show/',
  updateManageUserURL: BASE_URL + API_V1 + '/user/update/',
  createManageUserURL: BASE_URL + API_V1 + '/user/create',
  getKycDetailsByIdURL: BASE_URL + API_V1 + '/user/detail/',
  changeSMSStatusURL: BASE_URL + API_V1 + '/user/sms_notify_status',
  approveKYCDocumentsURL: BASE_URL + API_V1 + '/approve-certificates/',
  getActiveCityListURL: BASE_URL + API_V1 + '/city/activelist',
  changeFamilyStatusURL : BASE_URL + API_V1 + '/patient/family-member-activate-profile/',
  getFamilyIdByURL : BASE_URL + API_V1 + '/patient/get-family-detail/',
  getFamilyRelation : BASE_URL + API_V1 + '/patient/family-member-relation',
  createFamilyURL : BASE_URL + API_V1 + '/patient/family-member-add' ,
  updateFamilyURL : BASE_URL + API_V1 + '/patient/family-member-edit',
  redeemPointsURL : BASE_URL + API_V1 + '/doctor/update/redeem-points',
  /* SETTINGS API */
  getSettingsDataURL: BASE_URL + API_V1 + '/configuration/list',
  getSettingsSaveDataURL: BASE_URL + API_V1 + '/configuration/update',
  getSettingsRemoveImageURL: BASE_URL + API_V1 + '/configuration/delete-image/',
  // getSettingsImageDataURL: BASE_URL + API + '/configuration/images',
  getSettingsImageDataURL: BASE_URL + API_V1 + '/config/logo',

  /* MANAGE CATEGORY - API */
  getAllCategoryListURL: BASE_URL + API_V1 + '/category/list',
  getCategoryByIdURL: BASE_URL + API_V1 + '/category/show/',
  changeCategoryStatusURL: BASE_URL + API_V1 + '/category/change_status',
  deleteCategoryURL: BASE_URL + API_V1 + '/category/delete/',
  updateCategoryURL: BASE_URL + API_V1 + '/category/update/',
  createCategoryURL: BASE_URL + API_V1 + '/category/create',
  getCategoryTreeviewURL : BASE_URL + API_V1 + '/category/treeview/ng6',
  createCategoryTreeURL : BASE_URL + API_V1 + '/category/save',
  parentCategoryListURL: BASE_URL + API_V1 + '/category/parent_list/',
  getActiveCategoryURL: BASE_URL + API_V1 + '/category/dropdown-list?type=0',
  getMedicineDiseaseListURL: BASE_URL + API_V1 + '/category/inventory-list',
  getPharmaciesList: BASE_URL + API_V1 + '/pharmacy/subadmin/list',
  getHospitalsList: BASE_URL + API_V1 + '/hospital/subadmin/list',
  getDoctorsList: BASE_URL + API_V1 + '/consultations/dashboard/docSearch',
  getInventoryList: BASE_URL + API_V1 + '/pharmacy/inventory/list/v1/',
  addIndividualMedicine: BASE_URL + API_V1 + '/pharmacy/inventory/medicine-store',
  getIndividualMedicineById: BASE_URL + API_V1 + '/pharmacy/individual/medicine/show/',
  deleteProductImagesURL: BASE_URL + API_V1 + '/pharmacy/individual/medicine/delete-image/',
  updateIndividualMedicine: BASE_URL + API_V1 + '/pharmacy/inventory/medicine-update',
  changeStatusIndvMedicine: BASE_URL + API_V1 + '/pharmacy/individual/medicine/change_status/',
  changeStatusprescription: BASE_URL + API_V1 + '/pharmacy/updateInventoryStatus/',
  deleteIndvMedicine: BASE_URL + API_V1 + '/pharmacy/individual/medicine/delete/',
  getBatchViewList: BASE_URL + API_V1 + '/pharmacy/individual/medicine/batches/',
  getitemwisepurchase: BASE_URL + API_V1 + '/pharmacy/individual/medicine/supplier/',
  addEditIndividualMedicineBatch: BASE_URL + API_V1 + '/pharmacy/individual/medicine/batch/addedit/',
  deleteBatch: BASE_URL + API_V1 + '/pharmacy/individual/medicine/batch/delete/',

  /* SYSTEM PERMISSIONS - API */
  getAllRoleListURL: BASE_URL + API_V1 + '/role/list',
  changeRoleStatusURL: BASE_URL + API_V1 + '/role/change_status',
  createRoleURL: BASE_URL + API_V1 + '/role/create',
  updateRoleURL: BASE_URL + API_V1 + '/role/update/',
  getAllPermissionListURL: BASE_URL + API_V1 + '/permission/list',
  assignPermissionURL: BASE_URL + API_V1 + '/permission/role_assign/',
  deleteRoleURL: BASE_URL + API_V1 + '/role/delete/',

  updateProfileInfoURL: BASE_URL + API_V1 + '/subadmin/update_profile',
  changeProfilePassURL: BASE_URL + API_V1 + '/oauth/password/change',

  videoUploadURL: BASE_URL + '/front/api/v1/chunk/upload',

  /* MANAGE CONTACT - API */
  getAllContactListURL: BASE_URL + API_V1 + '/contact/list',
  deleteContactURL: BASE_URL + API_V1 + '/contact/delete/',

  /* Symptoms Management - API */
  getAllSymptomsListURL: BASE_URL + API_V1 + '/symptoms/list',
  changeSymptomsStatusURL: BASE_URL + API_V1 + '/symptoms/change_status/',
  deleteSymptomsURL: BASE_URL + API_V1 + '/symptoms/delete/',
  getSymptomByIdURL: BASE_URL + API_V1 + '/symptoms/show/',
  updateSymptomByIdURL: BASE_URL + API_V1 + '/symptoms/update/',
  createSymptomByURL: BASE_URL + API_V1 + '/symptoms/create',

  /* Specialization Management - API */
  getAllSpecializationsListURL: BASE_URL + API_V1 + '/specialtys/list',
  changeSpecializationStatusURL: BASE_URL + API_V1 + '/specialtys/change_status/',
  deleteSpecializationURL: BASE_URL + API_V1 + '/specialtys/delete/',
  getSpecializationByIdURL: BASE_URL + API_V1 + '/specialtys/show/',
  updateSpecializationByIdURL: BASE_URL + API_V1 + '/specialtys/update/',
  createSpecializationByURL: BASE_URL + API_V1 + '/specialtys/create',

  /* Disease Management - API */
  getAllDiseasesListURL: BASE_URL + API_V1 + '/disease/list',
  changeDiseaseStatusURL: BASE_URL + API_V1 + '/disease/change_status/',
  deleteDiseaseURL: BASE_URL + API_V1 + '/disease/delete/',
  getDiseaseByIdURL: BASE_URL + API_V1 + '/disease/show/',
  updateDiseaseByIdURL: BASE_URL + API_V1 + '/disease/update/',
  createDiseaseByURL: BASE_URL + API_V1 + '/disease/create',

  /* Doctor Management - API*/
  getDoctorDetailsByIdURL: BASE_URL + API_V1 + '/doctor/detail/',
  addEditClinic: BASE_URL + API_V1 + '/doctor/add_update_clinic/',
  deleteClinicURL: BASE_URL + API_V1 + '/doctor/deleteclinic/',
  updatePersonalInfo: BASE_URL + API_V1 + '/doctor/edit-personal-profile/',
  updateProfessionalInfo: BASE_URL + API_V1 + '/doctor/edit-professional-profile/',
  deleteDoctorAccountURL: BASE_URL + API_V1 + '/doctor/delete/',
  addDoctorInfoURL: BASE_URL + API_V1 + '/doctor/add_doctor',

  /* Front End Route - API*/
  getActiveSpecialitiesListURL: BASE_URL + API_V1_FRONT + '/list-specialties',
  getActiveSymptomsListURL: BASE_URL + API_V1_FRONT + '/list-symptoms',
  documentDownloadAPIURL : BASE_URL + API_V2_FRONT + '/download',

  /* Pharmacy Management - API*/
  getPharmacyDetailsByIdURL: BASE_URL + API_V1 + '/pharmacy/detail/',
  updatePharmcyTimingsURL: BASE_URL + API_V1 + '/pharmacy/edit-operational-schedule/',
  updatePharmcyPersonalDetailsURL: BASE_URL + API_V1 + '/pharmacy/edit-personal-profile/',
  updatePharmcyProfessionalDetailsURL: BASE_URL + API_V1 + '/pharmacy/edit-professional-profile/',
  deletePharmacyAccountURL: BASE_URL + API_V1 + '/pharmacy/delete/',
  addPharmacyInfoURL: BASE_URL + API_V1 + '/pharmacy/add_pharmacy',
  getIndividualPharmacyList: BASE_URL + API_V1 + '/pharmacy/individual/list',
  updateIndividualPharmacyList: BASE_URL + API_V1 + '/pharmacy/individual/pharmacy-config-update',
  deletePharmDocument: BASE_URL + API_V1 + '/pharmacy/delete-document/',
 

  /* Patient Management - API*/
  getPatientDetailsByIdURL: BASE_URL + API_V1 + '/patient/detail/',
  createPatientURL: BASE_URL + API_V1 + '/patient/add_patient',
  updatePatientByIdURL: BASE_URL + API_V1 + '/patient/update/',
  updatePatientLifeStyleInfoByIdURL: BASE_URL + API_V1 + '/patient/update_lifestyle/',
  updatePatientVitalsInfoByIdURL: BASE_URL + API_V1 + '/patient/update_vital/',
  deletePatientAccountURL: BASE_URL + API_V1 + '/patient/delete/',
  addPatientMedicalHistoryURL: BASE_URL + API_V1 + '/medical-history/add/',
  getPatientMedicalHistoryListURL: BASE_URL + API_V1 + '/medical-history/list/',
  deletePatientMedicalHistory: BASE_URL + API_V1 + '/medical-history/delete/',
  getPatientMedicalHistoryDetailsByURL: BASE_URL + API_V1 + '/medical-history/view/',
  deletePatientMedicalHistoryDocumentURL: BASE_URL + API_V1 + '/medical-history/delete-document/',
  getConnectionListURL: BASE_URL + API_V1 + '/connections/',
  getInventoryListURL: BASE_URL + API_V1 + '/pharmacy/inventoryList/',
  getDiscountListURL: BASE_URL + API_V1 + '/pharmacy/discountedList/',
  deleteHistory: BASE_URL + API_V1 + '/medical-history/delete/',
  deleteDocument : BASE_URL + API_V1 + '/delete-certificates/',
  getPatientFamilyList : BASE_URL + API_V1 + '/patient/family-member-list',
  deleteFamily : BASE_URL + API_V1 + '/patient/family-member-delete/',
  patientGroup : BASE_URL + API_V1 + '/patient/update_p_group_assign',


  /* Doctor's Consultation Management - API */
  getAllDoctorsConsultationsListURL: BASE_URL + API_V1 + '/consultations/list',
  getViewDoctorsConsultationURL: BASE_URL + API_V1 + '/consultations/detail/',
  deleteConsultantUrl: BASE_URL + API_V1 + '/consultations/delete/',

  /* Order Management - API */
  getAllOrderListURL: BASE_URL + API_V1 + '/orders/list',
  getOrderByIdURL: BASE_URL + API_V1 + '/orders/detail/',
  changeOrderStatusDetailByIdURL: BASE_URL + API_V1 + '/orders/change_status_detail/',
  getOrderConnectionListURL: BASE_URL + API_V1 + '/orders/connection',
  changeOrderStatusURL: BASE_URL + API_V1 + '/orders/change_status/',
  deleteOrderUrl: BASE_URL + API_V1 + '/orders/delete/',
  deleteOrderDocument : BASE_URL + API_V1 + '/orders/delete-document/',
  uploadInvoice: BASE_URL + API_V1 + '/orders/generate_invoice/',
  updateAgentAllocationURL: BASE_URL + API_V1 + '/orders/update/agent_allocation/',

  /* Reviw - API */
  getReviewListURL: BASE_URL + API_V1 + '/reviews/list',
  deleteReviewURL: BASE_URL + API_V1 + '/reviews/delete/',

  /* Report - API */
  getUserReportListURL: BASE_URL + API_V1 + '/report/list',
  deleteUserReportURL: BASE_URL + API_V1 + '/report/delete/',

  /* City Management - API */
  getCityListURL: BASE_URL + API_V1 + '/city/list',
  changeCityStatusURL: BASE_URL + API_V1 + '/city/change_status/',
  deleteCityURL: BASE_URL + API_V1 + '/city/delete/',
  getCityByIdURL: BASE_URL + API_V1 + '/city/show/',
  updateCityByIdURL: BASE_URL + API_V1 + '/city/update/',
  createCityByURL: BASE_URL + API_V1 + '/city/create',

  // Download API
  fileDownloadURL : BASE_URL + API_V1 + '/download',
  exportUsersURLDOC : BASE_URL + API_V1 + '/user/usersexportdocs',
  exportUsersURLPATS : BASE_URL + API_V1 + '/user/usersexportpats',
  exportUsersURLPHAR : BASE_URL + API_V1 + '/user/usersexportphar',
  exportConsultationURL : BASE_URL + API_V1 + '/consultationreportexcel',
  exportOrderURL : BASE_URL + API_V1 + '/orderreportnew',
  exportRewardURL : BASE_URL + API_V1 + '/points/pointsexportexcel',
  importListPatientURL : BASE_URL + API_V1 + '/import/patients',
  importInventoryMedicine: BASE_URL + API_V1 + '/pharmacy/individual/medicine/import/',
  exportInventoryMedicine: BASE_URL + API_V1 + '/pharmacy/individual/medicine/export/',

  /* Pharmacy Group - API */
  getAllPharmacyGroupListURL: BASE_URL + API_V1 + '/pharmacygroup/list',
  changePharmacyGroupStatusURL: BASE_URL + API_V1 + '/pharmacygroup/change_status/',
  deletePharmacyGroupURL: BASE_URL + API_V1 + '/pharmacygroup/delete/',
  getPharmacyGroupByIdURL : BASE_URL + API_V1 + '/pharmacygroup/show',
  updatePharmacyGroupByIdURL : BASE_URL + API_V1 + '/pharmacygroup/update',
  createPharmacyGroupByURL : BASE_URL + API_V1 + '/pharmacygroup/create',

  /* Reward - API */
  getRewardListURL: BASE_URL + API_V1 + '/points/list',
  getUniversalConfigURL: BASE_URL + API_V1 + '/points/get_uni_config',
  postUniversalConfigURL: BASE_URL + API_V1 + '/points/submit_uni_config',
  postEventConfigURL: BASE_URL + API_V1 + '/points/submit_event_config',
  getBulkPointsURL: BASE_URL + API_V1 + '/points/submit_bulk_points',
  getGenPharmacyListURL: BASE_URL + API_V1 + '/user/listpharmacy',
  getPatientListURL: BASE_URL + API_V1 + '/user/listpatient',
  getPharPatPointsListURL: BASE_URL + API_V1 + '/points/points_log',

  /* Reward - API */
  getReferralListURL: BASE_URL + API_V1 + '/referral/list',
  getNonGroupedPharmacyListURL: BASE_URL + API_V1 + '/user/non-grouped-pharmacy-list',
  addReferralURL: BASE_URL + API_V1 + '/referral/add_referral',
  exportReferralURL : BASE_URL + API_V1 + '/referral/referral-export',
  deleteReferralURL: BASE_URL + API_V1 + '/referral/delete/',
  changeReferralStatusURL: BASE_URL + API_V1 + '/referral/update/',
  updateReferralByIdURL: BASE_URL + API_V1 + '/referral/update/',
  getAllReferralListURL: BASE_URL + API_V1 + '/referral/all-referrals',

  /* Master Logs API */
  getTempApiListURL: BASE_URL + API_V1 + '/logs/getapitempdata',
  getTempApiListHospitalURL: BASE_URL + API_V1 + '/logs/getapitempdatahospital',
  getImportLogListURL: BASE_URL + API_V1 + '/pharmacy/individual/importlog',
  getBackendStatsURL: BASE_URL + API_V1 + '/backend-stats',

  /* purchase Management - API */
  purchasemanagementlist : BASE_URL + API_V1 + '/purchase/list',
  purchasemanagementdelete : BASE_URL + API_V1 + '/purchase/delete',
  purchasemanagementshow : BASE_URL + API_V1 + '/purchase/show/',
  exportpurchasemanagement: BASE_URL + API_V1 + '/purchase/export-purchase',
  // supplier management Api 
  getAllsuppliermanagement : BASE_URL + API_V1 + '/supplier/list',
  deletesuppliermanagement : BASE_URL + API_V1 + '/supplier/delete',

  createdsuppliermanagement : BASE_URL + API_V1 + '/supplier/store',
  updatesuppliermanagement : BASE_URL + API_V1 + '/supplier/update/',
  
  viewSuppliermanagement  : BASE_URL + API_V1 + '/supplier/show/',

    /* Hospital Management - API */
  hospitalmanagementlist : BASE_URL + API_V1 + '/hospital/list',
  hospitaldelete : BASE_URL + API_V1 + '/hospital/delete',
  hospitalchangeManageUserStatusURL: BASE_URL + API_V1 + '/hospital/update-status',
  createdhospitalmanagement : BASE_URL + API_V1 + '/hospital/store',
  hospitalchangeview  : BASE_URL + API_V1 + '/hospital/view/',
  hospitalmanagement : BASE_URL + API_V1 + '/hospital/update/',
  getdoctorpharclist : BASE_URL + API_V1 + '/hospital/get-doctor-pharc-list',
  getdoctorlist : BASE_URL + API_V1 + '/notification/patient_list',
  docpharmcmap : BASE_URL + API_V1 + '/hospital/doc-pharmc-map',
    /* Hospital Management subadmin- API */
    getadminhospitallist : BASE_URL + API_V1 + '/hospital/get-admin-hospital-list',
    getmapadminhospital : BASE_URL + API_V1 + '/hospital/map-admin-hospital',

    // Inquiry-management Api 
    hospitalleadgetSinglehospitalID: BASE_URL + API_V1 + '/hospital/dashboard/listids',
    hospitalgetSinglehospitalID: BASE_URL + API_V1 + '/hospital/subadmin/list',
    inquirygetAllsuppliermanagement : BASE_URL + API_V1 + '/hospital/inquiry/list',
    inquiryhospitaldelete : BASE_URL + API_V1 + '/hospital/delete/inquiry',
    inquirysevicessource : BASE_URL + API_V1 + '/hospital/sevices/list',
    exportinquirmanagement: BASE_URL + API_V1 + '/hospital/export/inquiry',
    createdinquirmanagement : BASE_URL + API_V1 + '/hospital/add/inquiry',
    editinquirymanagement: BASE_URL + API_V1 + '/hospital/view/inquiry',
    updateinquiry: BASE_URL + API_V1 + '/hospital/update/inquiry',
    importinquirmanagement: BASE_URL + API_V1 + '/import/inquiry',
    updateInquiryAgentAllocation: BASE_URL + API_V1 + '/hospital/update/inquiry/agent_allocation/',

   ///Appointment Management
    appointmentManagementlist : BASE_URL + API_V1 + '/patient/appointment/list',
    appointmentManagementview  : BASE_URL + API_V1 + '/patient/appointment/details/',
    appointmentdelete : BASE_URL + API_V1 + '/patient/delete/appointment',
    getclinicappointment : BASE_URL + API_V1 + '/patient/get_clinic/appointmentslot',
    appointmentslotupdate : BASE_URL + API_V1 + '/patient/appointment/status-update/',
    exportappointmentslotupdate : BASE_URL + API_V1 + '/patient/export/appointmentslot',

    //billing-management
    billingManagementlist : BASE_URL + API_V1 + '/billing/list',
    billingManagementdelete : BASE_URL + API_V1 + '/billing/delete',
    billingManagementview  : BASE_URL + API_V1 + '/billing/view/',
    exportbillingManagement: BASE_URL + API_V1 + '/billing/exportList',
    billingManagementService : BASE_URL + API_V1 + '/consultations/dashboard/serviceSearch',
    createbillingManagementService : BASE_URL + API_V1 + '/billing/create/bill',
    editbillingManagementService : BASE_URL + API_V1 + '/billing/get-selected-services',
    editbillingUpdateService : BASE_URL + API_V1 + '/billing/update/bill',
    generateBillInvoiceUpdateService : BASE_URL + API_V1 + '/billing/generate-bill-invoice',


    //ipd-management
    ipdManagementlist : BASE_URL + API_V1 + '/ipd/admission_list',
    dropdownWardlist : BASE_URL + API_V1 + '/ipd/ward_list',
    ipdcounterNumberlist : BASE_URL + API_V1 + '/ipd/ward_list/',
    ipdManagementdelete : BASE_URL + API_V1 + '/ipd/delete_admission', 
    ipdipdbedCounter : BASE_URL + API_V1 + '/ipd/bed_counter',
    ipdManagementview  : BASE_URL + API_V1 + '/ipd/admission_details/',
    exportipdmanagement: BASE_URL + API_V1 + '/ipd/admission_list_export',

    //notification-management Api
    notificationConfigurationUrl:BASE_URL + API_V1 + '/notification/configuration',
    notificationConfigurationList:BASE_URL + API_V1 + '/notification/configuration-list',
    notificationnotificationcronallowed :BASE_URL + API_V1 + '/notification/cron-allowed',
    notificationBulkcommunication :BASE_URL + API_V1 + '/notification/send-bulk-communication',

   //diagnostic-management
   diagnosticManagementList :BASE_URL + API_V1 + '/hospital/diagnostic-listing',
   diagnosticviewview  : BASE_URL + API_V1 + '/hospital/diagnostic-view',
   diagnosticservicedelete: BASE_URL + API_V1 + '/hospital/diagnostic/service-delete/',
   servicetoggle: BASE_URL + API_V1 + '/hospital/diagnostic/service-toggle',
   hospitaladdlabservice: BASE_URL + API_V1 + '/hospital/add/lab-service',
   updateservicepackage: BASE_URL + API_V1 + '/hospital/diagnostic/service-update/',
   packageservicesadd: BASE_URL + API_V1 + '/hospital/diagnostic/services-list',
   packageservicesexport: BASE_URL + API_V1 + '/hospital/diagnostic/services-export',

   // Diagnostics Management 
   diagnosticsManagementList :BASE_URL + API_V1 + '/diagnostic/lab/order/list',
   diagnosticsManagementview :BASE_URL + API_V1 + '/diagnostic/lab/order/view/',
   diagnosticsManagementdelete :BASE_URL + API_V1 + '/diagnostic/lab/order/delete',
   diagnosticsManagementupdate :BASE_URL + API_V1 + '/diagnostic/lab/order/update/',

   // Hospital Slots
   hospitalmanageslot :BASE_URL + API_V1 + '/hospital/manage/slot',
   hospitalslotView :BASE_URL + API_V1 + '/hospital/view/slot_list/',
   
   //inquiryManagementview
   inquiryManagementview : BASE_URL + API_V1 + '/hospital/view/inquiry/details/',
  
  // Add Appointment
  patientSearch : BASE_URL + API_V1 + '/consultations/dashboard/patientSearch',
  doctorClinicdetails : BASE_URL + API_V1 + '/consultations/dashboard/get-doctor-clinic-details',
  createNewAppointment : BASE_URL + API_V1 + '/consultations/dashboard/create-new-appointment-from-pannel',
    

  //ai bot 
  aibot : BASE_URL + API_V1 + '/billing/ai/process',
  processAiAppointment: BASE_URL + API_V1 + '/patient/ai/process/appointment',
    

  //whatsapp management
  whatsappPharmacyList: BASE_URL + API_V1 + '/whatsapp/pharmacy-list',
  whatsappCreateConfig: BASE_URL + API_V1 + '/whatsapp/create-config',
  whatsappConfigList: BASE_URL + API_V1 + '/whatsapp/list',
  whatsappStatusChange: BASE_URL + API_V1 + '/whatsapp/config-status-change/',
  whatsappUpdateConfig: BASE_URL + API_V1 + '/whatsapp/update-config/',
  whatsappViewConfig: BASE_URL + API_V1 + '/whatsapp/view-config/',

};

